var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-home-banner bg-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "),_vm._t("message")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }